import { Divider } from '@material-ui/core';

import { createPortal } from 'react-dom';
import {
  Container,
  ActionMenu,
  StyledIcon,
  StyledActionButton,
  DeselectButton,
  NumberWrapper,
  SelectedWrapper,
  StyledTooltip
} from './style';
import { TextColor } from '../../enums';

export interface BulkMenuAction {
  color?: string;
  icon?: JSX.Element;
  label: string;
  tooltip?: string;
  onClick: () => void;
}

interface BulkMenuProps {
  totalSelected: number;
  actions: BulkMenuAction[];
  onCancel: () => void;
  showLabels?: boolean;
}

export const SBulkMenu = ({
  totalSelected,
  actions,
  onCancel,
  showLabels = false
}: BulkMenuProps) => {
  const content = (
    <Container>
      <SelectedWrapper noWrap fontColor={TextColor.DarkGrey}>
        <NumberWrapper>{totalSelected}</NumberWrapper>
        Selected
      </SelectedWrapper>

      <Divider flexItem orientation="vertical" />

      <ActionMenu>
        {actions?.map(({ color, icon, label, tooltip, onClick }) =>
          showLabels ? (
            <StyledTooltip
              title={tooltip || ''}
              key={label}
              arrow
              disableHoverListener={!tooltip}>
              <StyledActionButton
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClick();
                }}
                startIcon={icon}
                style={{ borderColor: color, color: color || undefined }}>
                {label}
              </StyledActionButton>
            </StyledTooltip>
          ) : (
            <StyledTooltip title={label} key={label} arrow>
              <StyledIcon
                onClick={e => {
                  e.preventDefault();
                  e.stopPropagation();
                  onClick();
                }}
                style={{
                  borderColor: color
                }}>
                {icon}
              </StyledIcon>
            </StyledTooltip>
          )
        )}
      </ActionMenu>

      <Divider flexItem orientation="vertical" />

      <DeselectButton variant="text" onClick={onCancel} color="primary">
        Cancel
      </DeselectButton>
    </Container>
  );

  return createPortal(content, document.getElementsByTagName('main')[0]);
};
